import {Component, model, output} from '@angular/core';

import {FormsModule} from '@angular/forms';
import {BaseInput} from '../base-input/base-input';

@Component({
  selector: 'app-checkbox',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.css'
})
export class CheckboxComponent extends BaseInput {
  checked = model(false)

  valueChange = output<boolean>();

  onCheckboxChange(event: Event) {
    const target = event.target as HTMLInputElement;
    this.checked.set(target.checked);
    this.valueChange.emit(this.checked());
  }
}
